import React, {useState, useEffect, useRef, useContext, Fragment} from "react";
import axios from "axios";
import {useHistory, useParams} from 'react-router-dom'
import Card from "../../../components/Card";
import {Field, Form, Formik} from "formik"
import ModalMsg from "../../../components/ModalMsg";
import * as Yup from "yup";
import {LoaderContext} from "../../../context/LoaderContext";
import {TranslateContext} from "../../../context/TranslateContext";
import LabelErroreCampo from "../../../components/LabelErroreCampo";
import NsFormikScrollToError from "../../../components/NsFormikScrollToError";
import NsBtnBack from "../../../components/buttons/NsBtnBack";

function ModificaTipiCarrozzeria() {
    const {id} = useParams()

    const [loadingData, setLoadingData] = useState(true);
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);

    const {startChiamata, endChiamata} = useContext(LoaderContext);
    const {traduci} = useContext(TranslateContext);

    const history = useHistory();
    const formikRef = useRef();

    function getTipoCarrozzeria() {
        startChiamata()
        axios
            .get(process.env.REACT_APP_API_ENDPOINT + "/api/rfi/veicolo/carrozzeria/" + id)
            .then((response) => {
                let val = response.data.data;
                setLoadingData(false);

                if (formikRef.current) {
                    formikRef.current.setFieldValue("id_tipo_carrozzeria", val.id_tipo_carrozzeria);
                    formikRef.current.setFieldValue("descrizione", val.descrizione);
                    formikRef.current.setFieldValue("sort", val.sort);
                }
                endChiamata()
            });
    }

    useEffect(() => {
        if (loadingData) {
            if (id && id !== '') {
                getTipoCarrozzeria();
            }
        }
    }, [id]);

    const SignupSchema = Yup.object().shape({
        id_tipo_carrozzeria: Yup.string()
            .max(15, traduci('Attenzione! Hai inserito troppi caratteri'))
            .required(traduci('Questo campo è obbligatorio')),
        descrizione: Yup.string()
            .max(50, traduci('Attenzione! Hai inserito troppi caratteri'))
            .required(traduci('Questo campo è obbligatorio')),
        sort: Yup.string()
            .required(traduci('Questo campo è obbligatorio')),
    });

    const closeModal = () => setShow(false);

    return (
        <Card
            icon={'fas fa-car'}
            title={id ? 'Modifica Tipo Carrozzeria' : 'Inserisci Tipo Carrozzzeria'}
            getBottoniDx={() =>
                <Fragment>
                    <NsBtnBack/>
                    <button type="button" id="salva" name="salva"
                            className="btn btn-card"
                            onClick={() => {
                                if (formikRef.current) {
                                    formikRef.current.handleSubmit()
                                }
                            }}>
                        <i className="fas fa-save"/> Salva
                    </button>
                </Fragment>
            }
        >
            <ModalMsg
                show={show}
                handleClose={closeModal}
                testo={modalMsg}/>
            <Formik
                initialValues={{
                    id_tipo_carrozzeria: '',
                    descrizione: '',
                    sort: '0'
                }}
                innerRef={formikRef}
                validationSchema={SignupSchema}
                onSubmit={values => {
                    if (id) {
                        startChiamata()
                        axios
                            .put(process.env.REACT_APP_API_ENDPOINT + "/api/rfi/veicolo/carrozzeria/" + id,
                                values)
                            .then((response) => {
                                if (response.data.result === 0) {
                                    endChiamata()
                                    history.goBack();
                                } else {
                                    setModalMsg(response.data.description);
                                    setShow(true);
                                    endChiamata()
                                }
                            });
                    } else {
                        startChiamata()
                        axios
                            .post(process.env.REACT_APP_API_ENDPOINT + "/api/rfi/veicolo/carrozzeria/",
                                values)
                            .then((response) => {
                                if (response.data.result === 0) {
                                    endChiamata()
                                    history.goBack();
                                } else {
                                    setModalMsg(response.data.description);
                                    setShow(true);
                                    endChiamata()
                                }
                            });
                    }
                }}
            >
                {({errors, touched, submitCount}) => (
                    <Form className="row g-3">
                        <div className="col-md-12">
                            <label htmlFor="id_tipo_carrozzeria" className="form-label">Codice tipo*:</label>
                            <Field
                                name="id_tipo_carrozzeria"
                                className="form-control"
                                readOnly={id}
                            />
                            <LabelErroreCampo errors={errors} touched={touched} name={"id_tipo_carrozzeria"}
                                              submitCount={submitCount}/>
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="descrizione" className="form-label">Tipo di carrozzeria*:</label>
                            <Field
                                name="descrizione"
                                className="form-control"
                            />
                            <LabelErroreCampo errors={errors} touched={touched} name={"descrizione"}
                                              submitCount={submitCount}/>
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="sort" className="form-label">Ordinamento*:</label>
                            <Field
                                name="sort"
                                className="form-control"
                                type={"number"}
                                onWheel={(e) => e.target.blur()} // Prevent default scrolling behavior
                            />
                            <LabelErroreCampo errors={errors} touched={touched} name={"sort"}
                                              submitCount={submitCount}/>
                        </div>

                        <NsFormikScrollToError submitCount={submitCount} errors={errors}/>
                    </Form>
                )}
            </Formik>
        </Card>
    );
}

export default ModificaTipiCarrozzeria;